// extracted by mini-css-extract-plugin
export default {"container":"NotFoundStation_container__achiZ","wrapper":"NotFoundStation_wrapper__AKGrB","body":"NotFoundStation_body__F9pxK","link":"NotFoundStation_link__ApD36"};